import { apiClient } from "./apiClient";

export type NotificationCategory =
  | "booking"
  | "subscription"
  | "payment"
  | "teacher_student"
  | "course"
  | "account"
  | "system";

export type NotificationPriority = "low" | "normal" | "high";

export interface Notification {
  id: string;
  type: string;
  data: {
    title?: {
      en?: string;
      ar?: string;
    };
    message: {
      en?: string;
      ar?: string;
    };
    link?: string;
    category?: NotificationCategory;
    priority?: NotificationPriority;
  };
  read_at: string | null;
  created_at: string;
}

export interface NotificationsResponse {
  notifications: {
    data: Notification[];
    current_page: number;
    last_page: number;
    total: number;
  };
  unread_count: number;
}

export const getNotifications = async (page = 1) => {
  const response = await apiClient.get<NotificationsResponse>(`/api/notifications?page=${page}`);
  return response.data;
};

export const markAsRead = async (id: string) => {
  const response = await apiClient.post(`/api/notifications/${id}/read`);
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await apiClient.post(`/api/notifications/read-all`);
  return response.data;
};
